namespace GeniuzPOS.Lookups {
    export namespace LookupSubCategory1Service {
        export const baseUrl = 'Lookups/LookupSubCategory1';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LookupSubCategory1Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Lookups/LookupSubCategory1/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>LookupSubCategory1Service)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
